import styled from "@emotion/styled";
import { theme } from "@product/scmp-sdk";

import { setFullViewportWidthStyles } from "shared/lib/styles";

import IconSCMPPlusLogo from "./icons/icon-scmp-plus-logo.svg";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}

  margin-block-start:24px;
`;
export const PaywallContainer = styled.div`
  display: none;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  max-inline-size: 660px;
  margin-block: 0;
  margin-inline: auto;
  padding-block-start: 188px;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const Wrapper = styled.div``;

type StyledLogoContainerProps = {
  $isLoggedIn: boolean;
};

export const LogoContainer = styled.div<StyledLogoContainerProps>`
  display: flex;
  justify-content: ${props => (props.$isLoggedIn ? "center" : "flex-start")};

  padding-inline-start: ${props => (props.$isLoggedIn ? "0" : "28px")};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  justify-content: center;

  padding-block-start: 32px;
`;

export const StyledIconSCMPPlusLogo = styled(IconSCMPPlusLogo)``;
